import { Button, Text } from '@/lib/mx-asurion-ui-react';
import { FooterDisclaimer } from './FooterDisclaimer';
import { FooterLinks } from './FooterLinks';
import { FooterLogo } from './FooterLogo';
import {
  DisclaimerArea,
  GridLayout,
  LinksArea,
  LogoArea,
  StyledFooter,
  StyledFooterWrapper,
} from './elements';

type Props = {
  linkData: FooterLink[];
  disclaimerText?: string;
};

type FooterLink = {
  href: string;
  text: string;
};

export const Footer = ({ linkData, disclaimerText }: Props) => (
  <StyledFooterWrapper>
    <StyledFooter>
      <GridLayout>
        <LogoArea>
          <FooterLogo />
        </LogoArea>
        <LinksArea>
          <FooterLinks
            cookieConsentButton={
              <Button
                className="ot-sdk-show-settings !inline-block !no-underline"
                variant="text"
                color="secondary"
              >
                Cookie Settings
              </Button>
            }
            linkData={linkData}
          />
        </LinksArea>
        <DisclaimerArea>
          <FooterDisclaimer>
            <Text size={0}>{disclaimerText}</Text>
          </FooterDisclaimer>
        </DisclaimerArea>
      </GridLayout>
    </StyledFooter>
  </StyledFooterWrapper>
);
